import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { api } from "src/shared/setup/API/api";

export const UseBalancePiesModalidade = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const { filterHome, setValuesBalancePiesModalidade } = useMetricsContext();

  const handleSubmit = () => {
    api
      .get(
        `/metrics/producao-modalidade?start_date=${filterHome.startDate}
        &end_date=${filterHome.endDate}
        &is_received=TRUE`
      )
      .then(({ data }) => setValuesBalancePiesModalidade(data.data))
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      );
  };

  return { handleSubmit };
};
